import { DefaultColorAliases, DefaultColors, DefaultVariables } from './variables-default';

export const Colors = {
	BLACK: `var(--black, ${DefaultColors.BLACK})`,
	DARK_GRAY1: `var(--dark-gray1, ${DefaultColors.DARK_GRAY1})`,
	DARK_GRAY2: `var(--dark-gray2, ${DefaultColors.DARK_GRAY2})`,
	DARK_GRAY3: `var(--dark-gray3, ${DefaultColors.DARK_GRAY3})`,
	DARK_GRAY4: `var(--dark-gray4, ${DefaultColors.DARK_GRAY4})`,
	DARK_GRAY5: `var(--dark-gray5, ${DefaultColors.DARK_GRAY5})`,
	GRAY1: `var(--gray1, ${DefaultColors.GRAY1})`,
	GRAY2: `var(--gray2, ${DefaultColors.GRAY2})`,
	GRAY3: `var(--gray3, ${DefaultColors.GRAY3})`,
	GRAY4: `var(--gray4, ${DefaultColors.GRAY4})`,
	GRAY5: `var(--gray5, ${DefaultColors.GRAY5})`,
	LIGHT_GRAY1: `var(--light-gray1, ${DefaultColors.LIGHT_GRAY1})`,
	LIGHT_GRAY2: `var(--light-gray2, ${DefaultColors.LIGHT_GRAY2})`,
	LIGHT_GRAY3: `var(--light-gray3, ${DefaultColors.LIGHT_GRAY3})`,
	LIGHT_GRAY4: `var(--light-gray4, ${DefaultColors.LIGHT_GRAY4})`,
	LIGHT_GRAY5: `var(--light-gray5, ${DefaultColors.LIGHT_GRAY5})`,
	WHITE: `var(--white, ${DefaultColors.WHITE})`,
	BLUE1: `var(--blue1, ${DefaultColors.BLUE1})`,
	BLUE2: `var(--blue2, ${DefaultColors.BLUE2})`,
	BLUE3: `var(--blue3, ${DefaultColors.BLUE3})`,
	BLUE4: `var(--blue4, ${DefaultColors.BLUE4})`,
	BLUE5: `var(--blue5, ${DefaultColors.BLUE5})`,
	GREEN1: `var(--green1, ${DefaultColors.GREEN1})`,
	GREEN2: `var(--green2, ${DefaultColors.GREEN2})`,
	GREEN3: `var(--green3, ${DefaultColors.GREEN3})`,
	GREEN4: `var(--green4, ${DefaultColors.GREEN4})`,
	GREEN5: `var(--green5, ${DefaultColors.GREEN5})`,
	ORANGE1: `var(--orange1, ${DefaultColors.ORANGE1})`,
	ORANGE2: `var(--orange2, ${DefaultColors.ORANGE2})`,
	ORANGE3: `var(--orange3, ${DefaultColors.ORANGE3})`,
	ORANGE4: `var(--orange4, ${DefaultColors.ORANGE4})`,
	ORANGE5: `var(--orange5, ${DefaultColors.ORANGE5})`,
	RED1: `var(--red1, ${DefaultColors.RED1})`,
	RED2: `var(--red2, ${DefaultColors.RED2})`,
	RED3: `var(--red3, ${DefaultColors.RED3})`,
	RED4: `var(--red4, ${DefaultColors.RED4})`,
	RED5: `var(--red5, ${DefaultColors.RED5})`,
	VERMILION1: `var(--vermilion1, ${DefaultColors.VERMILION1})`,
	VERMILION2: `var(--vermilion2, ${DefaultColors.VERMILION2})`,
	VERMILION3: `var(--vermilion3, ${DefaultColors.VERMILION3})`,
	VERMILION4: `var(--vermilion4, ${DefaultColors.VERMILION4})`,
	VERMILION5: `var(--vermilion5, ${DefaultColors.VERMILION5})`,
	ROSE1: `var(--rose1, ${DefaultColors.ROSE1})`,
	ROSE2: `var(--rose2, ${DefaultColors.ROSE2})`,
	ROSE3: `var(--rose3, ${DefaultColors.ROSE3})`,
	ROSE4: `var(--rose4, ${DefaultColors.ROSE4})`,
	ROSE5: `var(--rose5, ${DefaultColors.ROSE5})`,
	VIOLET1: `var(--violet1, ${DefaultColors.VIOLET1})`,
	VIOLET2: `var(--violet2, ${DefaultColors.VIOLET2})`,
	VIOLET3: `var(--violet3, ${DefaultColors.VIOLET3})`,
	VIOLET4: `var(--violet4, ${DefaultColors.VIOLET4})`,
	VIOLET5: `var(--violet5, ${DefaultColors.VIOLET5})`,
	INDIGO1: `var(--indigo1, ${DefaultColors.INDIGO1})`,
	INDIGO2: `var(--indigo2, ${DefaultColors.INDIGO2})`,
	INDIGO3: `var(--indigo3, ${DefaultColors.INDIGO3})`,
	INDIGO4: `var(--indigo4, ${DefaultColors.INDIGO4})`,
	INDIGO5: `var(--indigo5, ${DefaultColors.INDIGO5})`,
	COBALT1: `var(--cobalt1, ${DefaultColors.COBALT1})`,
	COBALT2: `var(--cobalt2, ${DefaultColors.COBALT2})`,
	COBALT3: `var(--cobalt3, ${DefaultColors.COBALT3})`,
	COBALT4: `var(--cobalt4, ${DefaultColors.COBALT4})`,
	COBALT5: `var(--cobalt5, ${DefaultColors.COBALT5})`,
	TURQUOISE1: `var(--turquoise1, ${DefaultColors.TURQUOISE1})`,
	TURQUOISE2: `var(--turquoise2, ${DefaultColors.TURQUOISE2})`,
	TURQUOISE3: `var(--turquoise3, ${DefaultColors.TURQUOISE3})`,
	TURQUOISE4: `var(--turquoise4, ${DefaultColors.TURQUOISE4})`,
	TURQUOISE5: `var(--turquoise5, ${DefaultColors.TURQUOISE5})`,
	FOREST1: `var(--forest1, ${DefaultColors.FOREST1})`,
	FOREST2: `var(--forest2, ${DefaultColors.FOREST2})`,
	FOREST3: `var(--forest3, ${DefaultColors.FOREST3})`,
	FOREST4: `var(--forest4, ${DefaultColors.FOREST4})`,
	FOREST5: `var(--forest5, ${DefaultColors.FOREST5})`,
	LIME1: `var(--lime1, ${DefaultColors.LIME1})`,
	LIME2: `var(--lime2, ${DefaultColors.LIME2})`,
	LIME3: `var(--lime3, ${DefaultColors.LIME3})`,
	LIME4: `var(--lime4, ${DefaultColors.LIME4})`,
	LIME5: `var(--lime5, ${DefaultColors.LIME5})`,
	GOLD1: `var(--gold1, ${DefaultColors.GOLD1})`,
	GOLD2: `var(--gold2, ${DefaultColors.GOLD2})`,
	GOLD3: `var(--gold3, ${DefaultColors.GOLD3})`,
	GOLD4: `var(--gold4, ${DefaultColors.GOLD4})`,
	GOLD5: `var(--gold5, ${DefaultColors.GOLD5})`,
	SEPIA1: `var(--sepia1, ${DefaultColors.SEPIA1})`,
	SEPIA2: `var(--sepia2, ${DefaultColors.SEPIA2})`,
	SEPIA3: `var(--sepia3, ${DefaultColors.SEPIA3})`,
	SEPIA4: `var(--sepia4, ${DefaultColors.SEPIA4})`,
	SEPIA5: `var(--sepia5, ${DefaultColors.SEPIA5})`,
};

export const ColorAliases = {
	PT_INTENT_PRIMARY: `var(--pt-intent-primary, ${DefaultColorAliases.PT_INTENT_PRIMARY})`,
	PT_INTENT_SUCCESS: `var(--pt-intent-success, ${DefaultColorAliases.PT_INTENT_SUCCESS})`,
	PT_INTENT_WARNING: `var(--pt-intent-warning, ${DefaultColorAliases.PT_INTENT_WARNING})`,
	PT_INTENT_DANGER: `var(--pt-intent-danger, ${DefaultColorAliases.PT_INTENT_DANGER})`,
	PT_APP_BACKGROUND_COLOR: `var(--pt-app-background-color, ${DefaultColorAliases.PT_APP_BACKGROUND_COLOR})`,
	PT_DARK_APP_BACKGROUND_COLOR: `var(--pt-dark-app-background-color, ${DefaultColorAliases.PT_DARK_APP_BACKGROUND_COLOR})`,
	PT_OUTLINE_COLOR: `var(--pt-outline-color, ${DefaultColorAliases.PT_OUTLINE_COLOR})`,
	PT_TEXT_COLOR: `var(--pt-text-color, ${DefaultColorAliases.PT_TEXT_COLOR})`,
	PT_TEXT_COLOR_MUTED: `var(--pt-text-color-muted, ${DefaultColorAliases.PT_TEXT_COLOR_MUTED})`,
	PT_TEXT_COLOR_DISABLED: `var(--pt-text-color-disabled, ${DefaultColorAliases.PT_TEXT_COLOR_DISABLED})`,
	PT_HEADING_COLOR: `var(--pt-heading-color, ${DefaultColorAliases.PT_HEADING_COLOR})`,
	PT_LINK_COLOR: `var(--pt-link-color, ${DefaultColorAliases.PT_LINK_COLOR})`,
	PT_DARK_TEXT_COLOR: `var(--pt-dark-text-color, ${DefaultColorAliases.PT_DARK_TEXT_COLOR})`,
	PT_DARK_TEXT_COLOR_MUTED: `var(--pt-dark-text-color-muted, ${DefaultColorAliases.PT_DARK_TEXT_COLOR_MUTED})`,
	PT_DARK_TEXT_COLOR_DISABLED: `var(--pt-dark-text-color-disabled, ${DefaultColorAliases.PT_DARK_TEXT_COLOR_DISABLED})`,
	PT_DARK_HEADING_COLOR: `var(--pt-dark-heading-color, ${DefaultColorAliases.PT_DARK_HEADING_COLOR})`,
	PT_DARK_LINK_COLOR: `var(--pt-dark-link-color, ${DefaultColorAliases.PT_DARK_LINK_COLOR})`,
	PT_TEXT_SELECTION_COLOR: `var(--pt-text-selection-color, ${DefaultColorAliases.PT_TEXT_SELECTION_COLOR})`,
	PT_ICON_COLOR: `var(--pt-icon-color, ${DefaultColorAliases.PT_ICON_COLOR})`,
	PT_ICON_COLOR_HOVER: `var(--pt-icon-color-hover, ${DefaultColorAliases.PT_ICON_COLOR_HOVER})`,
	PT_ICON_COLOR_DISABLED: `var(--pt-icon-color-disabled, ${DefaultColorAliases.PT_ICON_COLOR_DISABLED})`,
	PT_ICON_COLOR_SELECTED: `var(--pt-icon-color-selected, ${DefaultColorAliases.PT_ICON_COLOR_SELECTED})`,
	PT_DARK_ICON_COLOR: `var(--pt-dark-icon-color, ${DefaultColorAliases.PT_DARK_ICON_COLOR})`,
	PT_DARK_ICON_COLOR_HOVER: `var(--pt-dark-icon-color-hover, ${DefaultColorAliases.PT_DARK_ICON_COLOR_HOVER})`,
	PT_DARK_ICON_COLOR_DISABLED: `var(--pt-dark-icon-color-disabled, ${DefaultColorAliases.PT_DARK_ICON_COLOR_DISABLED})`,
	PT_DARK_ICON_COLOR_SELECTED: `var(--pt-dark-icon-color-selected, ${DefaultColorAliases.PT_DARK_ICON_COLOR_SELECTED})`,
	PT_DIVIDER_BLACK: `var(--pt-divider-black, ${DefaultColorAliases.PT_DIVIDER_BLACK})`,
	PT_DARK_DIVIDER_BLACK: `var(--pt-dark-divider-black, ${DefaultColorAliases.PT_DARK_DIVIDER_BLACK})`,
	PT_DARK_DIVIDER_WHITE: `var(--pt-dark-divider-white, ${DefaultColorAliases.PT_DARK_DIVIDER_WHITE})`,
	PT_CODE_TEXT_COLOR: `var(--pt-code-text-color, ${DefaultColorAliases.PT_CODE_TEXT_COLOR})`,
	PT_DARK_CODE_TEXT_COLOR: `var(--pt-dark-code-text-color, ${DefaultColorAliases.PT_DARK_CODE_TEXT_COLOR})`,
	PT_CODE_BACKGROUND_COLOR: `var(--pt-code-background-color, ${DefaultColorAliases.PT_CODE_BACKGROUND_COLOR})`,
	PT_DARK_CODE_BACKGROUND_COLOR: `var(--pt-dark-code-background-color, ${DefaultColorAliases.PT_DARK_CODE_BACKGROUND_COLOR})`,
};

export const Variables = {
	PT_GRID_SIZE: `var(--pt-grid-size, ${DefaultVariables.PT_GRID_SIZE})`,
	PT_FONT_FAMILY: `var(--pt-font-family, ${DefaultVariables.PT_FONT_FAMILY})`,
	PT_FONT_FAMILY_MONOSPACE: `var(--pt-font-family-monospace, ${DefaultVariables.PT_FONT_FAMILY_MONOSPACE})`,
	PT_FONT_SIZE: `var(--pt-font-size, ${DefaultVariables.PT_FONT_SIZE})`,
	PT_FONT_SIZE_LARGE: `var(--pt-font-size-large, ${DefaultVariables.PT_FONT_SIZE_LARGE})`,
	PT_FONT_SIZE_SMALL: `var(--pt-font-size-small, ${DefaultVariables.PT_FONT_SIZE_SMALL})`,
	PT_LINE_HEIGHT: `var(--pt-line-height, ${DefaultVariables.PT_LINE_HEIGHT})`,
	ICONS16_FAMILY: `var(--icons16-family, ${DefaultVariables.ICONS16_FAMILY})`,
	ICONS20_FAMILY: `var(--icons20-family, ${DefaultVariables.ICONS20_FAMILY})`,
	PT_ICON_SIZE_STANDARD: `var(--pt-icon-size-standard, ${DefaultVariables.PT_ICON_SIZE_STANDARD})`,
	PT_ICON_SIZE_LARGE: `var(--pt-icon-size-large, ${DefaultVariables.PT_ICON_SIZE_LARGE})`,
	PT_BORDER_RADIUS: `var(--pt-border-radius, ${DefaultVariables.PT_BORDER_RADIUS})`,
	PT_BUTTON_HEIGHT: `var(--pt-button-height, ${DefaultVariables.PT_BUTTON_HEIGHT})`,
	PT_BUTTON_HEIGHT_SMALL: `var(--pt-button-height-small, ${DefaultVariables.PT_BUTTON_HEIGHT_SMALL})`,
	PT_BUTTON_HEIGHT_SMALLER: `var(--pt-button-height-smaller, ${DefaultVariables.PT_BUTTON_HEIGHT_SMALLER})`,
	PT_BUTTON_HEIGHT_LARGE: `var(--pt-button-height-large, ${DefaultVariables.PT_BUTTON_HEIGHT_LARGE})`,
	PT_INPUT_HEIGHT: `var(--pt-input-height, ${DefaultVariables.PT_INPUT_HEIGHT})`,
	PT_INPUT_HEIGHT_LARGE: `var(--pt-input-height-large, ${DefaultVariables.PT_INPUT_HEIGHT_LARGE})`,
	PT_INPUT_HEIGHT_SMALL: `var(--pt-input-height-small, ${DefaultVariables.PT_INPUT_HEIGHT_SMALL})`,
	PT_NAVBAR_HEIGHT: `var(--pt-navbar-height, ${DefaultVariables.PT_NAVBAR_HEIGHT})`,
	PT_Z_INDEX_BASE: `var(--pt-z-index-base, ${DefaultVariables.PT_Z_INDEX_BASE})`,
	PT_Z_INDEX_CONTENT: `var(--pt-z-index-content, ${DefaultVariables.PT_Z_INDEX_CONTENT})`,
	PT_Z_INDEX_OVERLAY: `var(--pt-z-index-overlay, ${DefaultVariables.PT_Z_INDEX_OVERLAY})`,
	PT_BORDER_SHADOW_OPACITY: `var(--pt-border-shadow-opacity, ${DefaultVariables.PT_BORDER_SHADOW_OPACITY})`,
	PT_DROP_SHADOW_OPACITY: `var(--pt-drop-shadow-opacity, ${DefaultVariables.PT_DROP_SHADOW_OPACITY})`,
	PT_DARK_BORDER_SHADOW_OPACITY: `var(--pt-dark-border-shadow-opacity, ${DefaultVariables.PT_DARK_BORDER_SHADOW_OPACITY})`,
	PT_DARK_DROP_SHADOW_OPACITY: `var(--pt-dark-drop-shadow-opacity, ${DefaultVariables.PT_DARK_DROP_SHADOW_OPACITY})`,
	PT_ELEVATION_SHADOW_0: `var(--pt-elevation-shadow-0, ${DefaultVariables.PT_ELEVATION_SHADOW_0})`,
	PT_ELEVATION_SHADOW_1: `var(--pt-elevation-shadow-1, ${DefaultVariables.PT_ELEVATION_SHADOW_1})`,
	PT_ELEVATION_SHADOW_2: `var(--pt-elevation-shadow-2, ${DefaultVariables.PT_ELEVATION_SHADOW_2})`,
	PT_ELEVATION_SHADOW_3: `var(--pt-elevation-shadow-3, ${DefaultVariables.PT_ELEVATION_SHADOW_3})`,
	PT_ELEVATION_SHADOW_4: `var(--pt-elevation-shadow-4, ${DefaultVariables.PT_ELEVATION_SHADOW_4})`,
	PT_DARK_ELEVATION_SHADOW_0: `var(--pt-dark-elevation-shadow-0, ${DefaultVariables.PT_DARK_ELEVATION_SHADOW_0})`,
	PT_DARK_ELEVATION_SHADOW_1: `var(--pt-dark-elevation-shadow-1, ${DefaultVariables.PT_DARK_ELEVATION_SHADOW_1})`,
	PT_DARK_ELEVATION_SHADOW_2: `var(--pt-dark-elevation-shadow-2, ${DefaultVariables.PT_DARK_ELEVATION_SHADOW_2})`,
	PT_DARK_ELEVATION_SHADOW_3: `var(--pt-dark-elevation-shadow-3, ${DefaultVariables.PT_DARK_ELEVATION_SHADOW_3})`,
	PT_DARK_ELEVATION_SHADOW_4: `var(--pt-dark-elevation-shadow-4, ${DefaultVariables.PT_DARK_ELEVATION_SHADOW_4})`,
	PT_TRANSITION_EASE: `var(--pt-transition-ease, ${DefaultVariables.PT_TRANSITION_EASE})`,
	PT_TRANSITION_EASE_BOUNCE: `var(--pt-transition-ease-bounce, ${DefaultVariables.PT_TRANSITION_EASE_BOUNCE})`,
	PT_TRANSITION_DURATION: `var(--pt-transition-duration, ${DefaultVariables.PT_TRANSITION_DURATION})`,
	PT_INPUT_BOX_SHADOW: `var(--pt-input-box-shadow, ${DefaultVariables.PT_INPUT_BOX_SHADOW})`,
	PT_DIALOG_BOX_SHADOW: `var(--pt-dialog-box-shadow, ${DefaultVariables.PT_DIALOG_BOX_SHADOW})`,
	PT_POPOVER_BOX_SHADOW: `var(--pt-popover-box-shadow, ${DefaultVariables.PT_POPOVER_BOX_SHADOW})`,
	PT_TOOLTIP_BOX_SHADOW: `var(--pt-tooltip-box-shadow, ${DefaultVariables.PT_TOOLTIP_BOX_SHADOW})`,
	PT_DARK_INPUT_BOX_SHADOW: `var(--pt-dark-input-box-shadow, ${DefaultVariables.PT_DARK_INPUT_BOX_SHADOW})`,
	PT_DARK_DIALOG_BOX_SHADOW: `var(--pt-dark-dialog-box-shadow, ${DefaultVariables.PT_DARK_DIALOG_BOX_SHADOW})`,
	PT_DARK_POPOVER_BOX_SHADOW: `var(--pt-dark-popover-box-shadow, ${DefaultVariables.PT_DARK_POPOVER_BOX_SHADOW})`,
	PT_DARK_TOOLTIP_BOX_SHADOW: `var(--pt-dark-tooltip-box-shadow, ${DefaultVariables.PT_DARK_TOOLTIP_BOX_SHADOW})`,
}
